import React from "react";
import { whoPays } from "../../mt";
import glamorous, { Div } from "glamorous";
import { color, textColor, truncate } from "../../style/index";
import ButtonRound from "../blocks/ButtonRound";
import { css } from "glamor";
import { tsDate } from "../../common";
import {Link} from 'react-router';

const Card = glamorous.div({
  height: 258,
  width: 319,
  ":hover": {
    cursor: "pointer"
  }
});

const buttonStyle = selected => {
  const shadow = selected
    ? {
        boxShadow:
          "inset 0 2px 4px 1px rgba(0, 0, 0, 0.3), 0 4px 8px 1px rgba(102,80,160,0.3)"
      }
    : null;
  return css(
    {
      position: "absolute",
      top: "18px",
      right: "-8px"
    },
    shadow
  );
};

const gradientStyle = {
  height: 30,
  background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%)",
  position: "absolute",
  bottom: 0
};

const PhotoGradient = glamorous.div({
  width: 184,
  right: 0,
  ...gradientStyle
});

const TripPhoto = glamorous.div(
  {
    height: 170,
    backgroundColor: "black",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  },
  ({ imageUrl }) => ({
    backgroundImage: imageUrl ? `url(${imageUrl})` : null,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  })
);

const Avatar = glamorous.div(
  {
    height: 100,
    width: 112,
    position: "absolute",
    top: 136,
    left: 24,
    borderRadius: 8,
    backgroundColor: "black",
    backgroundPosition: "center"
  },
  ({ imageUrl }) => ({
    backgroundImage: `url(${imageUrl})`
  })
);

const AvatarGradient = glamorous.div({
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
  width: "100%",
  ...gradientStyle
});

const Username = glamorous.p({
  position: "absolute",
  bottom: 0,
  margin: "0 0 0 5px",
  ...truncate
});

const WhoPays = glamorous.p({
  color: "white",
  position: "absolute",
  margin: 0,
  left: 158,
  fontWeight: 600,
  bottom: 0
});

const TripDetails = glamorous.div({
  background: "white",
  height: 87,
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
  paddingLeft: 158,
  color: color.BRAND_1
});

const Destination = glamorous.p({
  fontSize: 18,
  margin: 0,
  paddingTop: 16,
  paddingRight: 24,
  ...textColor.PURPLE,
  ...truncate
});

const Date = glamorous.p({
  margin: 0,
  ...textColor.LIGHT_GRAY
});

const formatDestination = (city, region, country) => {
  let locationArr = [];
  if (city) {
    locationArr.push(city);
  }
  if (region) {
    locationArr.push(region);
  }
  if (country) {
    locationArr.push(country);
  }
  return locationArr.join(", ");
};

const getTripImageUrl = photo => {
  let defaultPhoto = "https://s3.amazonaws.com/mstravel/prod/images/webapp/search_mini_map.png";
  if (photo) {
    return photo.data.length > 0 ? photo.data[0].path : defaultPhoto;
  }
  return defaultPhoto;
};

const TripCard = props => {
  const {
    account,
    photo,
    city,
    region,
    country,
    who_pays,
    leaving_dt,
    returning_dt,
    is_liked,
    id
  } = props.trip;

  return (
    <Card>
      <Div position="relative">

      { is_liked ? 
        <ButtonRound
          onClick={e => {
            e.stopPropagation();
          }}
          height={35}
          width={124}
          otherStyles={buttonStyle(is_liked)}
        >
          Asked!
        </ButtonRound> : 
        
        <ButtonRound
          onClick={()=> { props.joinTrip(id,props.index) }}
          height={35}
          width={124}
          otherStyles={buttonStyle(is_liked)}
        >
          Ask To Join
        </ButtonRound>
      }
        <PhotoGradient />
        <Link to={`/trip/${id}`}>
          <WhoPays>{whoPays(who_pays)}</WhoPays>
          <TripPhoto imageUrl={getTripImageUrl(photo)} />
          <Avatar imageUrl={account.data.profile.data.avatar.data.urls.thumbs}>
            <AvatarGradient />
            <Username>{account.data.username}</Username>
          </Avatar>
        </Link>
      </Div>

      <Link to={`/trip/${id}`}>
        <TripDetails>
          <Destination>{formatDestination(city, region, country)}</Destination>
          <Date>
            {tsDate(leaving_dt.date, "MMM DD")} &rarr;{" "}
            {tsDate(returning_dt.date, "MMM DD")}
          </Date>
        </TripDetails>
      </Link>
    </Card>
  );
};

export default TripCard;



// WEBPACK FOOTER //
// ./src/components/common/TripCard.jsx